<app-loader></app-loader>
<div class="card breadcrumbs">
</div>
<div class="table-card manager-profile">
    <div class="table-top ">
        <h3 class="sub-text">Profile</h3>
        <p-toast></p-toast>
        <form [formGroup]="managerForm" (ngSubmit)="submit()">

            <div class="light-bg">
                <div class="uploadImageOuter cstom-manager">
                    <img [src]="imageUrl || dummy" alt="" class="preview-image">
                    <div class="upload-remove">
                        <h5 *ngIf="imageUrl"><a (click)="clearImage()">Remove</a></h5>
                    </div>
                    <div class="editImage" >
                        <input type="file" (change)="onImageSelected($event)" accept="image/*" id="imageInput"
                            style="opacity: 0;">
                        <em class="pi pi-pencil" for="imageInput" style="font-size: .8rem; color: #fff;"></em>
                    </div>
                    <div *ngIf="isProfileImgError">
                        <div class="validation-error">File size should be less than 5MB.</div>
                    </div>
                </div>
            </div>
            <div class="grid form-deatail">
                <div class="col-12 lg:col-6 custom-spacing-right">
                    <div class="flex flex-column formgrid">
                        <label for="firstName">First Name<span class="custom-star">*</span></label>
                        <input pInputText NoLeadingSpaceDirective placeholder="First Enter Name" id="firstName" maxlength="50"
                            aria-describedby="username-help" formControlName="name" />
                        <div *ngIf="managerForm.get('name')?.dirty || managerForm.get('name')?.touched">
                            <div *ngIf="managerForm.get('name')?.hasError('required')" class="validation-error">
                                This field is required*
                            </div>
                            <div *ngIf="!managerForm.get('name')?.hasError('required') &&
                                      managerForm.get('name')?.hasError('leadingSpace')" class="validation-error">
                                Last Name cannot start with a space.*
                            </div>
                            <div *ngIf="!managerForm.get('name')?.hasError('required') &&
                                      !managerForm.get('name')?.hasError('leadingSpace') &&
                                      managerForm.get('name')?.hasError('pattern')" class="validation-error">
                                Please enter only characters*
                            </div>
                            <div *ngIf="!managerForm.get('name')?.hasError('required') &&
                                      !managerForm.get('name')?.hasError('leadingSpace') &&
                                      !managerForm.get('name')?.hasError('pattern') &&
                                      managerForm.get('name')?.hasError('minlength')" class="validation-error">
                                Minimum 3 letters are required*
                            </div>
                        </div>
                       </div>
                    <div class="flex flex-column formgrid">
                        <label for="lastName">Last Name<span class="custom-star">*</span></label>
                        <input pInputText NoLeadingSpaceDirective placeholder="Last Enter Name" id="lastName" maxlength="50"
                            aria-describedby="username-help" formControlName="lastName">
                        <div *ngIf="managerForm.get('lastName')?.dirty || managerForm.get('lastName')?.touched">
                            <div *ngIf="managerForm.get('lastName')?.hasError('required')" class="validation-error">
                                This field is required*
                            </div>
                            <div *ngIf="!managerForm.get('lastName')?.hasError('required') &&
                                      managerForm.get('lastName')?.hasError('leadingSpace')" class="validation-error">
                                Last Name cannot start with a space.*
                            </div>
                            <div *ngIf="!managerForm.get('lastName')?.hasError('required') &&
                                      !managerForm.get('lastName')?.hasError('leadingSpace') &&
                                      managerForm.get('lastName')?.hasError('pattern')" class="validation-error">
                                Please enter only characters*
                            </div>
                            <div *ngIf="!managerForm.get('lastName')?.hasError('required') &&
                                      !managerForm.get('lastName')?.hasError('leadingSpace') &&
                                      !managerForm.get('lastName')?.hasError('pattern') &&
                                      managerForm.get('lastName')?.hasError('minlength')" class="validation-error">
                                Minimum 3 letters are required*
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-column formgrid country-code">
                        <label for="phoneNumber">Mobile number<span class="custom-star">*</span></label>
                        <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                            [disabled]="true" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                            [searchCountryFlag]="true" id="phoneNumber"
                            [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]"
                            [selectFirstCountry]="false" [selectedCountryISO]="countryISO" [maxLength]="10"
                            [phoneValidation]="true" [separateDialCode]="separateDialCode" customPlaceholder="Enter Mobile Number"
                            [numberFormat]="phoneNumberFormat.National" name="phone" formControlName="phone">
                        </ngx-intl-tel-input>
                        <div
                            *ngIf="!managerForm.get('phone').hasError('required') && managerForm.get('phone').touched && managerForm.get('phone').invalid">
                            <small class="validation-error">Mobile number is not valid*</small>
                        </div>
                    </div>
                    <div class="flex flex-column formgrid mb-0">
                        <label for="email">Email<span class="custom-star">*</span></label>
                        <input pInputText placeholder="Enter Email" id="email" aria-describedby="username-help"
                            formControlName="email" />
                        <div class="validation-error"
                            *ngIf="managerForm.get('email')?.invalid && (managerForm.get('email')?.dirty || managerForm.get('email')?.touched)">
                            <div class="validation-error">Enter a valid Email*</div>
                        </div>
                        <div
                            *ngIf="managerForm.get('email')?.hasError('required')  && (managerForm.get('email')?.dirty || managerForm.get('email')?.touched)">
                            <div class="validation-error"> Field is required*</div>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-6 custom-spacing-lright">
                    <div class="profile-rightbtn multiselect">
                        <div class="flex flex-column formgrid">
                            <label for="parkingLotName">Select Parking Lot<span class="custom-star">*</span></label>
                            <p-multiSelect [options]="parkingLotByStates" formControlName="parkingLotId"
                                defaultLabel="Select Parking Lot" optionLabel="name" id="parkingLotName" optionValue="id"
                                class="multiselect-custom" (onChange)="assignedParkingLots($event)">
                            </p-multiSelect>
                            <div
                                *ngIf="managerForm.get('parkingLotId')?.hasError('required')  && (managerForm.get('parkingLotId')?.dirty || managerForm.get('parkingLotId')?.touched)">
                                <div class="validation-error"> Field is required*</div>
                            </div>
                        </div>
                        <div class="flex flex-column formgrid">
                            <label for="createPassword">Create Password<span class="custom-star">*</span></label>
                            <input pPassword indicator="true" [feedback]="false" placeholder="Enter here" id="createPassword" formControlName="password" />
                            <div class="validation-error" *ngIf="managerForm.get('password')?.hasError('required') && (managerForm.get('password')?.dirty || managerForm.get('password')?.touched)">
                                <div class="validation-error">Field is required*</div>
                            </div>
                            <div *ngIf="managerForm.get('password')?.hasError('minlength')  && (managerForm.get('password')?.dirty || managerForm.get('password')?.touched)">
                                <div class="validation-error">Minimum 8 characters are required*</div>
                            </div>
                        </div>
                        <div class="flex flex-column formgrid custom-status active-toggle">
                            <label formControlName="isActive">Status</label>
                            <label class="switch">
                                <input type="checkbox" [checked]="userData?.isActive" />
                                <div class="slider round" (click)="managerStatus(userData.isActive)">
                                    <span class="on">Active</span>
                                    <span class="off">Inactive</span>
                                </div>
                              </label>
                        </div>
                        <div class="edit-outer">
                            <p-button label="Update" type="submit"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
